import React, { useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import axiosHttp from "../config/axios.interceptor";
import { errorResponseMessage } from "../shared/const.prop";
import { AuthContext } from "../contexts/AuthContext";

const DeleteAccount = () => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const handleSubmit = async () => {
    try {
      const submitDetails = await axiosHttp.post("remove-my-account");
      if (submitDetails.status === 201) {
        appContext.updateModalState();
        authContext.logout();
        appContext.updateNotificationState({
          show: true,
          message: "Your account is deleted successfully",
          type: "success",
        });
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      } else {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
    }
  };

  return (
    <>
      <div className="modal-body">
        <p>
          Please confirm. Your account will be permanently deleted within 24
          hours if you do not log in during this period.
        </p>
      </div>
      <div className="modal-footer mr-3">
        <div className="ml-auto mb-5">
          <div className="row">
            <div className=" text-center">
              <button
                type="button"
                className="btn btn-outline-primary prime-btn mr-1"
                onClick={() => appContext.updateModalState()}
              >
                Cancel
              </button>
            </div>
            <div className="">
              <button
                type="button"
                className="btn btn-primary prime-btn"
                data-dismiss="modal"
                onClick={handleSubmit}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteAccount;
